import { takeEvery, put, call } from "redux-saga/effects";
import {
  FETCH_DEDUCTIONS,
  CHANGE_DEDUCTION_STATUS,
  CHANGE_DEDUCTION_STATUS_SUCCESS,
  CHANGE_DEDUCTION_STATUS_FAILURE,
  CREATE_DEDUCTION_REQUEST,
  DELETE_DEDUCTION,
} from "./actionTypes";
import * as types from './actionTypes';
import {
  fetchDeductions,
  fetchDeductionsSuccess,
  fetchDeductionsFailure,
  changeDeductionStatus,
  changeDeductionStatusSuccess,
  changeDeductionStatusFailure,
  createDeductionSuccess,
  createDeductionFailure,
  deleteDeductionSuccess,
  deleteDeductionFailure,
} from "./actions";
import { get, post, update, del } from "../../../../helpers/api_helper";
import Swal from "sweetalert2";

// Fetch Deductions
function* fetchDeductionsSaga({ payload: { unitId } }) {
  try {
    const formData = new FormData();
    formData.append("unit_id", unitId);
    const response = yield call(post, process.env.REACT_APP_GET_DEDUCTIONS, formData);
    if (!response || response.status !== "success") {
      throw new Error(response?.message || "Failed to retrieve deductions!");
    }
    yield put(fetchDeductionsSuccess(response)); 
  } catch (error) {
    console.error("Saga API Error:", error); 
    yield put(fetchDeductionsFailure(error.message));
  }
}

function* changeDeductionStatusSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_CHANGE_DEDUCTION_STATUS, action.payload);

    if (!response || response.status !== 'success') {
      throw new Error(response?.message || 'Failed to update head status!');
    }

    yield put({ type: types.CHANGE_DEDUCTION_STATUS_SUCCESS, payload: response });

    Swal.fire('Success', response?.message, 'success');
  } catch (error) {
    Swal.fire({
      title: 'Error',
      text: error.message || 'Something went wrong while changing status!',
      icon: 'error',
      confirmButtonText: 'OK',
    });

    yield put({ type: types.CHANGE_DEDUCTION_STATUS_FAILURE, payload: error });
  }
}

// Create Deduction Saga
function* createDeductionSaga({ payload }) {
  try {
    const { formData, isEdit } = payload;
    const response = yield call(post, process.env.REACT_APP_CREATE_DEDUCTION, formData);

    if (response?.status === "success") {
      Swal.fire({
        icon: "success",
        title: "Success",
        text: response.message || "Deduction saved successfully!",
      });
      yield put(createDeductionSuccess(response));
      const unitId = formData.get("unit_id"); 
      if (unitId) {
        yield put(fetchDeductions(unitId));
      } else {
        console.log("unit_id is missing in formData, fetch not triggered");
      }
    } else {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: response.message || "Something went wrong!",
      });
      yield put(createDeductionFailure("Unexpected response format"));
    }
  } catch (error) {
    console.error("Saga API Error:", error);
    Swal.fire({
      icon: "error",
      title: "API Error",
      text: error.message || "An error occurred while saving the deduction",
    });
    yield put(createDeductionFailure(error.message));
  }
}

function* deleteDeductionSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_DELETE_DEDUCTION, action.payload);

    if (response?.status === "success") {
      Swal.fire({
        icon: "success",
        title: "Deleted!",
        text: response.message || "Deduction deleted successfully!",
      });
      yield put(deleteDeductionSuccess(response));
    } else {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: response.message || "Failed to delete deduction!",
      });
      yield put(deleteDeductionFailure("Unexpected response format"));
    }
  } catch (error) {
    console.error("Delete Deduction Saga Error:", error);
    Swal.fire({
      icon: "error",
      title: "API Error",
      text: error.message || "An error occurred while deleting the deduction",
    });
    yield put(deleteDeductionFailure(error.message));
  }
}

// Watcher Saga
function* payrollSetupDeductionSaga() {
  yield takeEvery(FETCH_DEDUCTIONS, fetchDeductionsSaga);  
  yield takeEvery(CHANGE_DEDUCTION_STATUS, changeDeductionStatusSaga);
  yield takeEvery(CREATE_DEDUCTION_REQUEST, createDeductionSaga);
  yield takeEvery(DELETE_DEDUCTION, deleteDeductionSaga);
}

export default payrollSetupDeductionSaga;
